import { StringEqualsComparatorFilterConverter } from '@leverege/molten/imagine';
function create(type) {
  return {
    ...StringEqualsComparatorFilterConverter,
    id: `custom.${type}.Equals.ComparatorFilterConverter`,
    type: `${type}.Equals`
  };
}
export default {
  create
};